import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cu-hero" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "cu-body bg-gondola" }
const _hoisted_4 = {
  class: "container mw-1356",
  style: {"max-width":"860px"}
}
const _hoisted_5 = { class: "cu-cards" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "cu-card-val" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "cu-card-val" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "cu-card-val" }
const _hoisted_12 = {
  key: 3,
  class: "cu-card"
}
const _hoisted_13 = { class: "cu-card-val" }
const _hoisted_14 = {
  key: 4,
  class: "cu-card"
}
const _hoisted_15 = { class: "cu-card-val" }
const _hoisted_16 = { class: "cu-form-box" }
const _hoisted_17 = {
  key: 0,
  class: "cu-success"
}
const _hoisted_18 = {
  key: 0,
  class: "cu-error"
}
const _hoisted_19 = { class: "cu-row" }
const _hoisted_20 = { class: "cu-field" }
const _hoisted_21 = { class: "cu-field" }
const _hoisted_22 = {
  class: "cu-field",
  style: {"margin-top":"1rem"}
}
const _hoisted_23 = {
  class: "cu-field",
  style: {"margin-top":"1rem"}
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "border-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "cu-top-label" }, "CONTACT US", -1)),
        _createElementVNode("h1", null, _toDisplayString(_ctx.c.heading || 'Get In Touch'), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.c.subheading || "We're here to help — reach out any time"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.c.email)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: 'mailto:' + _ctx.c.email,
                class: "cu-card"
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "cu-card-icon" }, [
                  _createElementVNode("i", { class: "ti ti-mail" })
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "cu-card-label" }, "Email", -1)),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.c.email), 1)
              ], 8, _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.c.phone)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: 'tel:' + _ctx.c.phone,
                class: "cu-card"
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "cu-card-icon" }, [
                  _createElementVNode("i", { class: "ti ti-phone" })
                ], -1)),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "cu-card-label" }, "Phone / WhatsApp", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.c.phone), 1)
              ], 8, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.c.telegram)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.c.telegram,
                target: "_blank",
                rel: "noopener",
                class: "cu-card"
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "cu-card-icon" }, [
                  _createElementVNode("i", { class: "ti ti-brand-telegram" })
                ], -1)),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "cu-card-label" }, "Telegram", -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.c.telegram), 1)
              ], 8, _hoisted_10))
            : _createCommentVNode("", true),
          (_ctx.c.hours)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "cu-card-icon" }, [
                  _createElementVNode("i", { class: "ti ti-clock" })
                ], -1)),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "cu-card-label" }, "Support Hours", -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.c.hours), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.c.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "cu-card-icon" }, [
                  _createElementVNode("i", { class: "ti ti-map-pin" })
                ], -1)),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "cu-card-label" }, "Address", -1)),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.c.address), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "cu-form-title" }, "Send a Message", -1)),
          (_ctx.formSent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[16] || (_cache[16] = [
                _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1),
                _createTextVNode(" Message sent! We'll get back to you soon. ")
              ])))
            : (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                (_ctx.formError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.formError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", null, "Your Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                      type: "text",
                      required: "",
                      placeholder: "John Doe"
                    }, null, 512), [
                      [_vModelText, _ctx.form.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", null, "Email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                      type: "email",
                      required: "",
                      placeholder: "you@example.com"
                    }, null, 512), [
                      [_vModelText, _ctx.form.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", null, [
                    _createTextVNode("Phone Number "),
                    _createElementVNode("span", { style: {"color":"#666","font-size":"0.75rem"} }, "(optional — so we can call you)")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event)),
                    type: "tel",
                    placeholder: "+1 234 567 8900"
                  }, null, 512), [
                    [_vModelText, _ctx.form.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", null, "Message", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.message) = $event)),
                    required: "",
                    rows: "5",
                    placeholder: "How can we help?"
                  }, null, 512), [
                    [_vModelText, _ctx.form.message]
                  ])
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn cu-submit",
                  disabled: _ctx.formLoading
                }, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.formLoading ? 'Sending...' : 'Send Message'), 1)
                ], 8, _hoisted_24)
              ], 32))
        ])
      ])
    ]),
    _createVNode(_component_MainFooter),
    _createVNode(_component_CopyRight)
  ]))
}